"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
Object.defineProperty(exports, "mobileNavigationHeight", {
  enumerable: true,
  get: function get() {
    return _index.mobileNavigationHeight;
  }
});

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _debounce = _interopRequireDefault(require("../../utils/debounce"));

var _breakpoints = _interopRequireDefault(require("../../themes/parts/breakpoints"));

var _DesktopNavigation = _interopRequireDefault(require("./DesktopNavigation"));

var _MobileNavigation = _interopRequireDefault(require("./MobileNavigation"));

var _index = require("./MobileNavigation/components/MobileNavMenu/index.styles");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
} // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//


var PrimaryNavigation = function PrimaryNavigation(props) {
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isMobile = _useState2[0],
      setIsMobile = _useState2[1];

  var resizeHandler = (0, _react.useMemo)(function () {
    return (0, _debounce["default"])(function () {
      setIsMobile(window.innerWidth < _breakpoints["default"].md);
    });
  }, []);
  (0, _react.useEffect)(function () {
    window && window.addEventListener('resize', resizeHandler);
    resizeHandler();
    return function () {
      window && window.removeEventListener('resize', resizeHandler);
    };
  }, [resizeHandler]);
  return isMobile ? /*#__PURE__*/_react["default"].createElement(_MobileNavigation["default"], props) : /*#__PURE__*/_react["default"].createElement(_DesktopNavigation["default"], props);
};

PrimaryNavigation.propTypes = {
  LinkComponent: _propTypes.elementType.isRequired,
  items: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    name: _propTypes.string.isRequired,
    Icon: _propTypes.elementType,
    to: _propTypes.string.isRequired
  })).isRequired,
  ariaLabel: _propTypes.string,
  ariaLabelSubNavigation: _propTypes.string,
  mobileMoreText: _propTypes.string.isRequired,
  pathname: _propTypes.string.isRequired
};
PrimaryNavigation.defaultProps = {
  ariaLabel: 'Hoofdnavigatie',
  ariaLabelSubNavigation: 'Subnavigatie'
};
var _default = PrimaryNavigation;
exports["default"] = _default;